import React from 'react';
import {observer} from 'mobx-react';
import {PredictionOddsTooltip} from "./prediction.odds.tooltip";

export const PredictionOddsCells = observer(({
                                               odds,
                                               controller,
                                               isFirst,
                                               isLast,
                                               isSelected,
                                               onClick,
                                               bookmaker,
                                               bookieHrefModel,
                                               betsImpressionParams,
                                             }) => {
  const tooltipProps = {
      controller,
      option: odds,
      isSelected,
      onClick,
      bookmaker,
      bookieHrefModel,
      betsImpressionParams,
      isFirst,
      isLast,
    }

    return <PredictionOddsTooltip {...tooltipProps}/>
  }
);
